export interface Breadcrumb {
  text: string
  href: string
}

export interface Factoid {
  description: string
  image: string
  title: string
  url: string
}

export interface LoadState<T, U = Error> {
  isLoading: boolean
  data: T
  isLoaded: boolean
  error: U | null
}

export interface Seo {
  title: string | undefined
  description: string | undefined
  keywords: string | undefined
  seo_title?: string | undefined
  seo_description?: string | undefined
  seo_keywords?: string | undefined
}

export interface NewSeo {
  seo_title?: string
  seo_keywords?: string
  seo_description?: string
  seo_h1?: string
  seo_text?: string
}

export interface Breadcrumb {
  text: string
  href: string
}

export enum Mode {
  DEVELOPMENT = 'dev',
  STAGING = 'staging',
  BRANCH = 'branch',
  RELEASE = 'release',
  RC = 'rc',
}

/**
 * Перечисление соц. сетей для яндекс метрики
 */
export type SocialNetworkTypes = 'vkontakte' | 'odnoklassniki' | 'telegram'

/**
 * Ключи для кеширования результатов useAsyncData хуков
 */
export enum AsyncDataKey {
  MAIN_PAGE_DATA = 'main-page-data',
  MAIN_SLIDERS_DATA = 'main-sliders-data',
  DELIVERY_DATA = 'delivery-data',
  PAYMENT_DATA = 'payment-data',
  BONUSES_DATA = 'bonuses-data',
  SALES_DATA = 'sales-data',
  SALES_ARCHIVE_DATA = 'sales-archive-data',
  SALE_DATA = 'sale-data',
  SALE_ARCHIVE_DATA = 'sale-archive-data',
  SIMPLE_CATEGORIES_DATA = 'simple-categories-data',
  ONE_CATEGORY_DATA = 'category-data',
  ONE_CATEGORY_PRODUCTS_DATA = 'category-products-data',
  ONE_PRODUCT_DATA = 'one-product-data',
}
